export default __webpack_public_path__ + "static/media/photo3.236d8b99.svg";